<template>
  <div id="charts">
    <v-progress-linear v-if="pageLoading" class="mt-1" indeterminate></v-progress-linear>
    <v-toolbar color="rgb(250,250,250)" dense>
      <v-btn color="primary" fab x-small depressed @click.native="close">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title class="ml-2" color="primary">{{lang.user_statistics}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items></v-toolbar-items>
    </v-toolbar>

    <v-layout
      :class="{'mx-0 mt-1': $vuetify.breakpoint.xs,'mx-2 mt-1': $vuetify.breakpoint.smAndUp}"
      row
      wrap
      justify-center
    >
      <v-flex md11 pa-2>
        <v-card>
          <v-card-title>{{lang.users_by_country}}</v-card-title>
          <v-card-text>
            <canvas id="by_country"></canvas>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md5 pa-2>
        <v-card>
          <v-card-title>{{lang.players_users}}</v-card-title>
          <v-card-text>
            <canvas id="users_players"></canvas>
          </v-card-text>
        </v-card>
      </v-flex>
       <v-flex md5 pa-2>
        <v-card>
          <v-card-title>{{lang.users_providers}}</v-card-title>
          <v-card-text>
            <canvas id="providers_users"></canvas>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Chart from "chart.js";
import { coupons } from '../../coupons/coupons';
export default {
  data() {
    return {
      pageLoading: true,
      sortedCountriesNames: [],
      sortedCountriesCount: [],
      usersPlayersLabel: [],
      usersPlayersCount: [],
      usersProviders:[],
      usersProvidersCount:[]
    };
  },
  mounted() {
    this.init();

    this.createCountryChart();
    this.createUsersPlayersChart();
    this.createUsersProvidersChart();
    this.pageLoading = false;
    this.$store.commit("loading", false);
  },
  props: {
    users: {
      default: ""
    }
  },
  computed: {
    ...mapState(["loading", "fb", "adminUser", "lang", "page_name"])
  },
  methods: {
    close() {
      this.$emit("dialog", false);
    },
    init() {
      this.$store.commit("loading", true);
    },
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      const myChart = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options
      });
    },
    createCountryChart() {
      this.getCountries();
      var usersByCountryData = {
        type: "bar",
        data: {
          labels: this.sortedCountriesNames,
          datasets: [
            {
              label: this.lang.num_users,
              data: this.sortedCountriesCount,
              backgroundColor: this.poolColors(this.sortedCountriesNames)
            }
          ]
        },
        options: {
          responsive: true,
          tooltips: {
            enabled: true
          },
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25
                }
              }
            ]
          }
        }
      };

      this.createChart("by_country", usersByCountryData);
    },
    getCountries() {
      var countriesNames = [];
      var countriesCount = [];
      for (var i in this.users) {
        if (this.users[i] != null && this.users[i].location != null) {
          if (
            !this.isInArray(countriesNames, this.users[i].location.cf_country)
          ) {
            countriesNames.push(this.users[i].location.cf_country);
          }
        }
      }

      for (var i in countriesNames) {
        var count = 0;
        for (var j in this.users) {
          if (this.users[j] != null && this.users[j].location != null) {
            if (this.users[j].location.cf_country === countriesNames[i]) {
              count++;
            }
          }
        }
        countriesCount.push(count);
      }

      //sort

      var arrayOfObj = countriesNames.map(function(d, i) {
        return {
          label: d,
          data: countriesCount[i] || 0
        };
      });

      var sortedArrayOfObj = arrayOfObj.sort(function(a, b) {
        return b.data - a.data;
      });

      this.sortedCountriesCount = [];
      this.sortedCountriesNames = [];
      var me = this;
      sortedArrayOfObj.forEach(function(d) {
        me.sortedCountriesNames.push(d.label);
        me.sortedCountriesCount.push(d.data);
      });
    },
    createUsersPlayersChart() {
      this.getPlayers();
      var playersUsers = {
        type: "doughnut",
        data: {
          labels: this.usersPlayersLabel,
          datasets: [
            {
              data: this.usersPlayersCount,
              backgroundColor: this.poolColors(this.usersPlayersLabel)
            }
          ]
        },
        options: {
          responsive: true,
          tooltips: {
            enabled: true
          }
        }
      };

      this.createChart("users_players", playersUsers);
    },
    getPlayers() {
      this.usersPlayersLabel = [];
      this.usersPlayersCount = [];
      var allplayers = [];
      for (var i in this.users) {
        if (this.users[i] != null) {
          allplayers.push(this.users[i].players);
        }
      }
      function countDuplicates(obj, num) {
        obj[num] = ++obj[num] || 1;
        return obj;
      }

      var answer = allplayers.reduce(countDuplicates, {});
      this.usersPlayersLabel = Object.keys(answer);
      this.usersPlayersCount = Object.keys(answer).map(key => answer[key]);
      for(var i in this.usersPlayersLabel){
          this.usersPlayersLabel[i]="Users with "+ this.usersPlayersLabel[i]+" player(s)";
      }
    },
     createUsersProvidersChart() {
      this.getProviders();
      var providersUsers = {
        type: "doughnut",
        data: {
          labels: this.usersProviders,
          datasets: [
            {
              data: this.usersProvidersCount,
              backgroundColor: this.poolColors(this.usersProviders)
            }
          ]
        },
        options: {
          responsive: true,
          tooltips: {
            enabled: true
          }
        }
      };

      this.createChart("providers_users", providersUsers);
    },
    getProviders() {
      this.usersProviders = [];
      this.usersProvidersCount = [];
     
      for (var i in this.users) {
        if (this.users[i] != null && this.users[i].provider != null && this.users[i].provider != "") {
          
           if( !this.isInArray(this.usersProviders, this.users[i].provider)){
               
                this.usersProviders.push(this.users[i].provider);
            }
          
        }
      }
     for (var i in this.usersProviders) {
        var count = 0;
        for (var j in this.users) {
          if (this.users[j] != null && this.users[j].provider != null && this.users[j].provider != "") {
            
            if (this.users[j].provider === this.usersProviders[i]) {
               
              count++;
            }
          }
        }
        this.usersProvidersCount.push(count);
      }
    },
    isInArray(array, search) {
      return array.indexOf(search) >= 0;
    },
    dynamicColors() {
      var r = Math.floor(Math.random() * 255);
      var g = Math.floor(Math.random() * 255);
      var b = Math.floor(Math.random() * 255);
      return "rgba(" + r + "," + g + "," + b + ",1)";
    },
    poolColors(a) {
      var pool = [];
      for (var i in a) {
        pool.push(this.dynamicColors());
      }
      return pool;
    }
  }
};
</script>

<style lang="sass" scoped>

</style>